import getIterableElements from "./get-iterable-elements";

/**
 *
 * @param {IterableElementsProps | null} [targets]
 */
const getElementsMap = (targets = null) => {
  if (!targets) {
    return null;
  }

  const elements = getIterableElements(targets);

  if (!elements?.length) {
    return null;
  }

  const map = new Map();

  for (const element of elements) {
    const torus = element.Torus;

    if (torus) {
      if (torus.Main) {
        map.set(element, torus.Main);
      }
      if (torus.Group) {
        map.set(element, torus.Group);
      }
      if (torus.Container) {
        map.set(element, torus.Container);
      }
    }
  }

  return map;
};

export default getElementsMap;
